import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../../models/base/base-component';
import { BehaviorSubject, Observable } from 'rxjs';
import { OdataFilterGenerator } from '../../../../interfaces/odata-filter-generator';
import { InternalUserTableFilterRequest } from '../../../../models/shared/odata-filter-requests/internal-user-table-filter-request';
import { ScreenService } from '../../../../services/screen-service.service';

/**
 * @deprecated Use a TableHeaderInput instead.
 */
@Component({
  selector: 'app-table-column-search-bar',
  templateUrl: './table-column-search-bar.component.html',
  styleUrls: ['./table-column-search-bar.component.scss']
})
export class TableColumnSearchBarComponent extends BaseComponent implements OnChanges {
  constructor() {
    super();
  }

  @Input() searchForm!: OdataFilterGenerator;
  @Input() disabled: boolean = false;
  @Input() bindingProperty = '';
  @Input() placeholder = '';
  @Input() numbersOnly: boolean = false;
  @Output() searchValue = new EventEmitter<OdataFilterGenerator>();
  @Output() mobileInputClicked = new EventEmitter<void>();

  private screenService = inject(ScreenService);

  private _searchForm = new BehaviorSubject<OdataFilterGenerator>(new InternalUserTableFilterRequest());
  public readonly searchForm$ = this._searchForm as Observable<OdataFilterGenerator>;

  private _bindingProperty = new BehaviorSubject<string>('');
  public readonly bindingProperty$ = this._bindingProperty as Observable<string>;

  private _placeholder = new BehaviorSubject<string>($localize`Search`);
  public readonly placeholder$ = this._placeholder as Observable<string>;

  public isMobile$ = this.screenService.isMobile$;

  setupBindings(): void {}

  setupViews(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.searchForm) {
      this._searchForm.next(this.searchForm);
    }
    if (changes.bindingProperty) this._bindingProperty.next(this.bindingProperty);
    if (changes.placeholder) this._placeholder.next(this.placeholder);
  }

  public formSubmitted(form: OdataFilterGenerator): void {
    this.searchValue.emit(form);
  }

  public onMobileInputClick(): void {
    this.mobileInputClicked.emit();
  }
}
